import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { InfoIcon } from "lucide-react";
import * as React from "react";

export interface CustomPopoverProps {
  /** Título exibido no topo do popover */
  title: string;
  /** Texto descritivo dentro do popover */
  description: string;
  /** Ícone customizado (ReactNode). Se não fornecido, usa Info padrão */
  icon?: React.ReactNode;
  /** Tamanho do ícone (px) */
  iconSize?: number;
  /** Cor do ícone */
  iconColor?: string;
  /** Classes adicionais para estilizar o botão de trigger */
  triggerClassName?: string;
  /** Classes adicionais para estilizar o conteúdo do popover */
  contentClassName?: string;
}

export const CustomPopover: React.FC<CustomPopoverProps> = ({
  title,
  description,
  icon,
  iconSize = 3,
  iconColor = "#9CA3AF",
  triggerClassName = "",
  contentClassName = "w-64",
}) => {
  const renderIcon = () => {
    if (icon && React.isValidElement(icon)) {
      return React.cloneElement(icon as React.ReactElement, {
        size: iconSize,
        color: iconColor,
      });
    }
    return (
      <div className={`flex items-center justify-center max-w-5 max-h-5 ml-2`}>
        <InfoIcon
          className={`h-${iconSize} w-${iconSize} max-h-5 text-n-neutral`}
        />
      </div>
    );
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={`${triggerClassName} p-0`}
          style={{ width: iconSize, height: iconSize }}
        >
          {renderIcon()}
        </Button>
      </PopoverTrigger>
      <PopoverContent className={contentClassName} side="top" align="start">
        <div className="space-y-2">
          <h4 className="font-medium text-base">{title}</h4>
          <p className="text-sm text-n-text">{description}</p>
        </div>
      </PopoverContent>
    </Popover>
  );
};
